module.exports = __webpack_public_path__ + "img/nav_logo.0948e055.png";